import React from 'react'
import { useStore } from '../../../Stores/store';
import { DataGrid, GridColDef} from '@mui/x-data-grid';
import { Delete, Edit } from '@mui/icons-material';
import { observer } from 'mobx-react-lite';
import { Button } from '@mui/material';

export default observer(function NewsTable() {
    const { generalStore} = useStore();
    const { news, setSelectedNews, setNewsConfirmationModalStatus } = generalStore;

    let rows = [...news];

    const columns: GridColDef[] = React.useMemo(() => [
        { field: 'id', headerName: '', hide: true},
        { field: 'title', headerName: 'Title', flex: 1},
        {
            field: "",
            headerName: "Actions",
            disableClickEventBubbling: true,
            renderCell: (params) => {
              const onClickEdit = () => {                
                setSelectedNews(params.id as number);
              };

              const onClickDelete = () => {
                  setNewsConfirmationModalStatus(true, params.id as number);
              }
        
              return <div><Button onClick={onClickEdit}><Edit /></Button><Button onClick={onClickDelete}><Delete /></Button></div>;
            },
            flex: 1
        }
        ], [setNewsConfirmationModalStatus, setSelectedNews]);

    return (
        <DataGrid rows={rows} columns={columns} autoHeight={true} />
    )
});
